module.exports = __webpack_public_path__ + "static/media/069-laos.41639312.svg";